export enum AppPaths {
	LOGIN = 'login',
	RESET_PASSWORD = 'reset-password',
	SET_PASSWORD = 'set-password',

	ATTRIBUTES = 'attributes',
	ATTRIBUTE_VALUES = 'attribute-values',

	PRODUCTS = 'product',
	PRODUCT_MODELS = 'product-models',
	PRODUCT_GROUPS = 'product-groups',
	ORDERS = 'orders',
	SHIPPING_METHODS = 'shipping-methods',
	SHIPPING_PRIORITY = 'shipping-priority',

	ADMINS = 'admins',
	LOGIN_HISTORY = 'login-history',
	COMPANIES = 'companies',
	CLIENTS = 'clients',
	CONTACTS = 'contacts',
	CLIENT_GROUPS = 'client-groups',
	WORKERS = 'workers',
	PRODUCT_TYPE_CATEGORIES = 'product-type-categories',
	PRODUCT_TYPES = 'product-types',

	CONTENT = 'contents',

	ROLES = 'roles',
	ADMIN_GROUPS = 'admin-groups',
}
